import React from "react";

import { Col, Container, Row } from "react-bootstrap";


import Toolkit from "./Toolkit";
import { IoLogoFirebase } from "react-icons/io5";
import { FaCss3, FaHtml5, FaReact } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { SiRedux, SiTypescript, SiNextdotjs, SiMongodb, SiTailwindcss, SiExpress } from "react-icons/si";
import { DiNodejs } from "react-icons/di";
import Zoom from "react-reveal/Zoom";

export default function TechnicalSkill() {
  return (
   
    <div>
   
    <Zoom left cascade>
      <h1 className="mt-4">Professional <span className="purple">Skillset</span> </h1>
    </Zoom>
    <Container className="mt-4 ">
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={5} md={2} className="tech-icons">
        <FaReact />
        </Col>
        <Col xs={5} md={2} className="tech-icons ">
        <SiTypescript />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiNextdotjs />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiRedux />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <DiNodejs />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiExpress />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiMongodb />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiTailwindcss />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <IoLogoJavascript />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <FaHtml5 />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <FaCss3 />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <IoLogoFirebase />
        </Col>
      </Row>
    </Container>
    <Toolkit/>
  </div>
  );
}
